// One failure, one toast.
//
// Two layers can both have something to say about the same rejected request:
// the HTTP interceptor owns the cross-cutting refusals (401/403 — the session
// or the role, identical wherever they happen) and the feature surface owns
// what the ACTION was. Left alone both fire, and the admin reads two banners
// describing one failure.
//
// The interceptor marks the errors it has already spoken for; a surface asks
// before adding its own. Keyed on the thrown error object itself rather than on
// its text or a time window, so two genuinely separate failures that happen to
// carry the same code still each get their toast.
const reported = new WeakSet<object>();

function key(error: unknown): object | null {
  return typeof error === 'object' && error !== null ? error : null;
}

/** Record that this error has already been surfaced to the admin. */
export function markToastReported(error: unknown): void {
  const target = key(error);
  if (target) reported.add(target);
}

/** True when some layer has already toasted this exact error. */
export function wasToastReported(error: unknown): boolean {
  const target = key(error);
  return target !== null && reported.has(target);
}
